module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "genre",
    attrs: {
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('div', {}, [_c('h2', {
    staticClass: "_title"
  }, [_vm._v("Choose Language")]), _vm._v(" "), _c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "round": ""
    }
  }, [_vm._v("\n                Save\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/world.png")
    }
  })])]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    staticClass: "pgs_area",
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "pgs-wrapper",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "pgs"
  }, [_c('div', {
    staticClass: "pgs-inner-wrapper selected"
  }, [_c('div', {
    staticClass: "pgs-inner"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "pgs__title mb-0"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/uk-flag.svg"),
      "width": "20"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-2 flag-label"
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "highlight-circle"
  })])])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pgs-wrapper",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "pgs"
  }, [_c('div', {
    staticClass: "pgs-inner-wrapper"
  }, [_c('div', {
    staticClass: "pgs-inner"
  }, [_c('div', {
    staticClass: "dflex align-center justify-space-between"
  }, [_c('div', {
    staticClass: "pgs__title mb-0"
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/uk-flag.svg"),
      "width": "20"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-2 flag-label"
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "highlight-circle"
  })])])])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-831c3aae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/languageModal/index.vue
// module id = 1804
// module chunks = 180